import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomIAB = createSvgIcon(
  <path d="M11.45 4.804 6.696 6.916a1.36 1.36 0 0 0-.809 1.243v3.192c0 3.77 2.608 7.294 6.113 8.15 3.505-.856 6.113-4.38 6.113-8.15V8.159c0-.537-.32-1.026-.809-1.243L12.55 4.804a1.35 1.35 0 0 0-1.1 0m.55 7.22h4.754c-.36 2.798-2.227 5.29-4.754 6.071V12.03H7.246V8.16L12 6.046z" />,
  'CustomIAB',
);

export default CustomIAB;
